export enum WidgetState {
  Error,
  Good,
  Info,
  Loading,
  Warning
}


